import { Link } from "react-router-dom";
import { Logo } from "./Nav";
import { StatusDot, scrollToId } from "./primitives";


const COLS = [
    {
        title: "Product",
        links: [
            { label: "Capabilities", href: "#capabilities" },
            { label: "Command Center", href: "#command-center" },
            { label: "Docs", to: "/docs" },
            { label: "Changelog", to: "/changelog" },
        ],
    },
    {
        title: "Developers",
        links: [
            { label: "Documentation", to: "/docs" },
            { label: "API Reference", to: "/docs" },
            { label: "AI Assistant", to: "/docs" },
            { label: "Status", href: "#top" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "Manifesto", href: "#manifesto" },
            { label: "Contact", href: "#footer" },
        ],
    },
];

export default function Footer() {
    return (
        <footer
            id="footer"
            data-testid="site-footer"
            className="relative overflow-hidden border-t border-slate-800/70 bg-[#090D14]"
        >
            <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 lg:px-8">
                <div className="grid gap-14 lg:grid-cols-[1.1fr_1fr]">
                    <div>
                        <Logo />
                        <p className="mt-5 max-w-sm text-xs leading-relaxed text-slate-500 sm:text-sm">
                            The command center for outbound webhooks and streaming events.
                            Guaranteed delivery, cryptographic trust, total observability.
                        </p>

                        <div
                            data-testid="footer-status"
                            className="mt-6 flex items-center gap-2 font-mono text-[11px] text-slate-500"
                        >
                            <StatusDot />
                            All systems operational
                            <span className="text-slate-700">·</span>
                            <span className="text-emerald-400">99.999% (90d)</span>
                        </div>
                    </div>

                    <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
                        {COLS.map((col) => (
                            <div key={col.title}>
                                <h4 className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-500">
                                    {col.title}
                                </h4>
                                <ul className="mt-4 space-y-2.5">
                                    {col.links.map((l) => (
                                        <li key={l.label}>
                                            {l.to ? (
                                                <Link
                                                    to={l.to}
                                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                                    className="text-xs text-slate-400 transition-colors hover:text-cyan-300"
                                                >
                                                    {l.label}
                                                </Link>
                                            ) : (
                                                <a
                                                    href={l.href}
                                                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        scrollToId(l.href);
                                                    }}
                                                    className="text-xs text-slate-400 transition-colors hover:text-cyan-300"
                                                >
                                                    {l.label}
                                                </a>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-slate-800/70 pt-6 sm:flex-row sm:items-center">
                    <p className="font-mono text-[10px] text-slate-600">
                        © 2026 MDH Systems, Inc. — Every event, delivered.
                    </p>
                    <div className="flex gap-5 font-mono text-[10px] text-slate-600">
                        <a href="#footer" data-testid="footer-link-privacy" onClick={(e) => e.preventDefault()} className="hover:text-slate-400">Privacy</a>
                        <a href="#footer" data-testid="footer-link-terms" onClick={(e) => e.preventDefault()} className="hover:text-slate-400">Terms</a>
                        <a href="#footer" data-testid="footer-link-dpa" onClick={(e) => e.preventDefault()} className="hover:text-slate-400">DPA</a>
                    </div>
                </div>
            </div>

            <div
                aria-hidden="true"
                className="text-watermark font-display pointer-events-none select-none text-center text-[26vw] font-black leading-[0.75] tracking-tighter"
            >
                MDH
            </div>
        </footer>
    );
}
